import React, { useState } from "react";
import AdditionalTable from "./AdditionalTable";

const AdditionalInfo = ({ permission }) => {
  const [open, setOpen] = useState({ type: 1, open: false });
  const [mode, setMode] = useState({ type: 1, mode: "detail" });

  const accountHeaderButtons =
    mode.type === 1 && mode.mode === "modify"
      ? [
        {
          label: "완료",
          size: "sm",
          action: () => {
            setMode({ type: 1, mode: "detail" });
          },
        },
      ]
      : [
        {
          color: "gray-line",
          label: "편집하기",
          size: "sm",
          action: () => {
            setMode({ type: 1, mode: "modify" });
          },
        },
        {
          color: "line",
          label: "통장사본 추가",
          size: "sm",
          action: () => {
            setOpen({ type: 1, open: true });
          },
        },
      ];

  const stampHeaderButtons =
    mode.type === 2 && mode.mode === "modify"
      ? [
        {
          label: "완료",
          size: "sm",
          action: () => {
            setMode({ type: 2, mode: "detail" });
          },
        },
      ]
      : [
        {
          color: "gray-line",
          label: "편집하기",
          size: "sm",
          action: () => {
            setMode({ type: 2, mode: "modify" });
          },
        },
        {
          color: "line",
          label: "새 인감",
          size: "sm",
          action: () => {
            setOpen({ type: 2, open: true });
          },
        },
      ];

  const businessHeaderButtons =
    mode.type === 3 && mode.mode === "modify"
      ? [
        {
          label: "완료",
          size: "sm",
          action: () => {
            setMode({ type: 3, mode: "detail" });
          },
        },
      ]
      : [
        {
          color: "gray-line",
          label: "편집하기",
          size: "sm",
          action: () => {
            setMode({ type: 3, mode: "modify" });
          },
        },
        {
          color: "line",
          label: "새 사업자등록증",
          size: "sm",
          action: () => {
            setOpen({ type: 3, open: true });
          },
        },
      ];
  return (
    <div className="AdditionalInfo">
      <AdditionalTable
        type={1}
        mode={mode}
        open={open}
        setOpen={setOpen}
        headerButtons={permission.level > 1 ? accountHeaderButtons : []}
      />
      <AdditionalTable
        type={3}
        mode={mode}
        open={open}
        setOpen={setOpen}
        headerButtons={permission.level > 1 ? businessHeaderButtons : []}
      />
      <AdditionalTable
        type={2}
        mode={mode}
        open={open}
        setOpen={setOpen}
        headerButtons={permission.level > 1 ? stampHeaderButtons : []}
      />
    </div>
  );
};

export default AdditionalInfo;
